import { FunButton, LandingButton } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { useEventDetails } from 'hooks/user/useEvents/useEventDetails'
import { useIsMobile } from 'hooks/user/useIsMobile'
import { useNavigate } from 'react-router-dom'
import { EventType } from 'types/Event'

import { EventItem } from './components/eventItem'
import { WrapperRow } from './components/eventItem.stlye'
import { StyledCarousel, Title } from './eventCarousel.style'

interface EventCarouselProps {
    data: EventType[] | undefined
    isLoading: boolean
    error: any
}

export const EventCarousel = ({ data, isLoading, error }: EventCarouselProps) => {
    const { eventDetails, isLoading: eventDetailsLoading, error: eventDetailsError } = useEventDetails(data)
    const navigate = useNavigate()

    const getClosestEventsForEachShowAndLocation = (events: EventType[], count: number) => {
        const currentDate = new Date()

        const closestEventsByShowAndLocation = events
            .filter((event) => new Date(event.event_date) >= currentDate)
            .reduce(
                (acc, event) => {
                    const key = `${event.show_id}_${event.location_id}`
                    if (!acc[key] || new Date(event.event_date) < new Date(acc[key].event_date)) {
                        acc[key] = event
                    }
                    return acc
                },
                {} as Record<string, EventType>,
            )

        return Object.values(closestEventsByShowAndLocation)
            .sort((a, b) => new Date(a.event_date).getTime() - new Date(b.event_date).getTime())
            .slice(0, count)
    }

    const closestEvents = data ? getClosestEventsForEachShowAndLocation(data, 4) : []

    const handleRedirect = () => navigate(`/esemenyek/`)

    const isMobile = useIsMobile()

    return (
        <div className="carousel-container">
            <LoadingContainer isLoading={isLoading || eventDetailsLoading} error={error || eventDetailsError}>
                {!!isMobile && (
                    <WrapperRow style={{ marginBottom: '0rem', marginTop: '0rem' }}>
                        <FunButton
                            label="Aktuális jegyek"
                            icon="pi pi-arrow-right"
                            iconPos="right"
                            onClick={handleRedirect}
                            style={{ marginBottom: '0rem', marginTop: '0rem' }}
                        />
                    </WrapperRow>
                )}

                {!!isMobile && <Title>Műsor ajánló</Title>}
                {closestEvents.length > 0 ? (
                    <StyledCarousel
                        value={closestEvents}
                        itemTemplate={(event) => eventDetails[event.event_id] && <EventItem event={eventDetails[event.event_id]} />}
                        numVisible={1}
                        numScroll={1}
                        circular
                        autoplayInterval={5000}
                    />
                ) : (
                    <PlaceholderContainer>
                        <p>Hamarosan új események érkeznek!</p>
                    </PlaceholderContainer>
                )}
                {!isMobile && (
                    <WrapperRow>
                        <LandingButton label="JEGYVÁSÁRLÁS" onClick={handleRedirect} />
                    </WrapperRow>
                )}
            </LoadingContainer>
        </div>
    )
}
